// IMPORTURI ANGULAR

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule } from '@angular/common/http';

import { ReactiveFormsModule } from '@angular/forms';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
//TRADUCERI
// import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
// import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import { HttpClient } from '@angular/common/http';




// Componente
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { MainComponent } from './components/main/main.component';
import { FotoComponent } from './components/foto/foto.component';
import { TujaComponent } from './components/tuja/tuja.component';
import { BraziComponent } from './components/brazi/brazi.component';
import { IenuparComponent } from './components/ienupar/ienupar.component';
import { DiverseComponent } from './components/diverse/diverse.component';
import { FloriComponent } from './components/flori/flori.component';
import { ContactComponent } from './components/contact/contact.component';
import { AboutComponent } from './components/about/about.component';
import { HeaderComponent } from './components/header/header.component';
import { NewsComponent } from './components/main/news/news.component';



@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    MainComponent,
    FotoComponent,
    TujaComponent,
    BraziComponent,
    IenuparComponent,
    DiverseComponent,
    FloriComponent,
    ContactComponent,
    AboutComponent,
    HeaderComponent,
    NewsComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    
    ReactiveFormsModule


  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule { }
